export enum ContractPriceType {
  ByDistance = 'ByDistance',
  ByDistanceUnit = 'ByDistanceUnit',
  BySpot = 'BySpot',
  ByPackageSize = 'ByPackageSize',
  ByCommission = 'ByCommission'
}
